import { useMutation } from "@apollo/client";
import { ADD_HOSTED_BANK_ACCOUNT } from "../graphql/company";
import { loadStripe } from "@stripe/stripe-js";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { fullName } from "utils/fullName";

const useAddHostedBankAccount = (
  userData: any,
  setClientSecret: any,
  setAccountKey: any,
  setPaymentMethod: any,
  setOpenTerms: any,
) => {
  const { t } = useTranslation();
  const [addHostedBankAccount, { loading: loadingBank }] = useMutation(
    ADD_HOSTED_BANK_ACCOUNT,
    {
      onCompleted: async (data) => {
        try {
          setClientSecret(data.addHostedBankAccount.clientSecret);
          setAccountKey(data.addHostedBankAccount.accountKey);
          const stripe = await loadStripe(
            process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY as string,
            {
              stripeAccount: data.addHostedBankAccount.accountKey,
            },
          );

          const response = await stripe?.collectBankAccountForSetup({
            clientSecret: data.addHostedBankAccount.clientSecret,
            params: {
              payment_method_type: "us_bank_account",
              payment_method_data: {
                billing_details: {
                  name: fullName(userData?.user),
                  email: userData?.user?.email,
                },
              },
            },
          });

          if (response?.setupIntent?.status === "requires_confirmation") {
            setPaymentMethod(response?.setupIntent?.payment_method as string);
            setOpenTerms(true);
          }
          if (response?.error) {
            toast.error(t("SomethingWentWrongDescriptionWithSupport"));
          }
        } catch (error: any) {
          console.log(error);
          toast.error(t("SomethingWentWrongDescriptionWithSupport"));
        }
      },
    },
  );
  return { addHostedBankAccount, loadingBank };
};

export default useAddHostedBankAccount;
